import { GlobalEnumsAceBenutzerrolle } from '@/api/model-index';
import { ExtendedAuthenticationService } from '@/core/components/authentication/services/extended-authentication.service';
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(protected authenticationService: ExtendedAuthenticationService, protected router: Router) { }

  canActivate() {
    if (this.authenticationService.CurrentUser?.benutzerrolle != GlobalEnumsAceBenutzerrolle.Administrator)
        return this.router.navigateByUrl('/overview');

    return true;
  }
}
